var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.classes,on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c(_vm.icon,{tag:"component",attrs:{"color":_vm.iconColor}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }